import { render, staticRenderFns } from "./EmbedHeaderViewButtons.vue?vue&type=template&id=130155ee&"
import script from "./EmbedHeaderViewButtons.vue?vue&type=script&lang=js&"
export * from "./EmbedHeaderViewButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.FFR503Cp8cB3/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('130155ee')) {
      api.createRecord('130155ee', component.options)
    } else {
      api.reload('130155ee', component.options)
    }
    module.hot.accept("./EmbedHeaderViewButtons.vue?vue&type=template&id=130155ee&", function () {
      api.rerender('130155ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/EmbedHeader/EmbedHeaderViewButtons.vue"
export default component.exports